export default "__VITE_ASSET__DSLHs34Q__"